import React from "react";
import { Checkbox, FormControlLabel } from "@mui/material";

const CustomCheckbox = (props) => {
  const {
    label,
    checked,
    onChange,
    name,
    error = false,
    helperText = "",
    isReadOnly = false,
    isLock = false,
    disabled = false,
  } = props;

  return (
    <FormControlLabel
      control={
        <Checkbox
          checked={checked}
          error={!!error}
          helperText={helperText}
          disabled={isLock || disabled}
          onChange={(_, newValue) => { onChange(newValue) }}
          name={name}
          readOnly={isReadOnly}
        />
      }
    />
  );
};

export default CustomCheckbox;
